// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"4115a251","425":"af24a3b0","510":"7ea72032","532":"414d80e7","633":"802308e6","634":"311e0db3","922":"5310d8cd","937":"21a62c1b","972":"d635a25f"}[chunkId] + ".chunk.js";
};